import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=57128112&v-slot%3Adefault=a&"
import script from "./SignIn.vue?vue&type=script&lang=ts&"
export * from "./SignIn.vue?vue&type=script&lang=ts&"
import style0 from "./SignIn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VAppBar,VMain})
